import { ClickHandler, Ripple } from "../types";

export const rippleHandler: ClickHandler = ({ event, domeElement, setRipples }) => {
  const rect = domeElement.getBoundingClientRect();
  // Calculate exact pixel position relative to dome
  const x = event.clientX - rect.left;
  const y = event.clientY - rect.top;

  // Create ripple effect
  const newRipple: Ripple = {
    id: Date.now(),
    x,
    y,
  };

  setRipples((prev) => [...prev, newRipple]);

  // Remove ripple after animation completes
  setTimeout(() => {
    setRipples((prev) =>
      prev.filter((ripple) => ripple.id !== newRipple.id),
    );
  }, 700);
};


